// see also: //www.nutramax.biz/store/shopify/nmx.consumer.js Move supplement
// facts to second col Promise CA-09/12/2017
jQuery(document)
  .ready(function () {
    if (jQuery(".product-view").length) {
      subMent();
    }
  
  	
  $("[title*='FREE']").closest(".item.product").remove();
  window.setInterval(function(){ $("[title*='FREE']").closest(".item.product").remove(); },500);
  
  //FreeVariantWithMinPurchase(31247889203262, 40); 
  // omegamint
  RemoveFreeProduct();
  BlockFreeOrders();
  
  
  if ($("[testmode] #your-shopping-cart").length){
    // run in cart only
  	//AutoApplyCouponInCart("APRSP2020", "10% OFF (applied at checkout)");
    
  }
});


function AutoApplyCouponInCart(coupon_code, message){
  if ($(".cart.table-wrap .DiscountCode").length){
    $("[name='checkout']").css("opacity","1").val("Proceed to checkout");
    if ($(".cart.table-wrap .DiscountCode").text().trim() == coupon_code){
  		$(".cart.table-wrap .DiscountCode").text(message);
    } else {
      	$(".cart.table-wrap .DiscountCode").text("DISCOUNT: "+$(".cart.table-wrap .DiscountCode").text());
    }
  } else {
    $("[name='checkout']").css("opacity","0").val("Checking for discounts");
    $("#shopping-cart-totals-table").after('<div class="DiscountCode"></div>');
    console.log("checking for discount");
    $(".cart.table-wrap .DiscountCode").load("https://www.nutramaxstore.com/checkout/ .reduction-code__text:last", function(){
      if ($(".cart.table-wrap .DiscountCode").text().trim() == ""){
      	ActivateCoupon(coupon_code, message);
      } else {
      	AutoApplyCouponInCart(coupon_code, message);
      }
    });
  }
}

function ActivateCoupon(coupon_code, message){
  $("body").append('<div class="AutoApplyCouponInCart" style="display:none;"></div>');
  console.log("activating discount");
  $(".AutoApplyCouponInCart").load("https://www.nutramaxstore.com/discount/"+coupon_code+" .reduction-code__text:last", function(){ 
    $(".cart.table-wrap .DiscountCode").remove();
    AutoApplyCouponInCart(coupon_code, message);
    //$("#shopping-cart-totals-table").after('<div class="DiscountCode">'+message+'</div>');
  });
}


// function CheckForDiscountCode(callback){
//   $(".cart.table-wrap .DiscountCode").data("callback",callback);
//   if ($(".cart.table-wrap .DiscountCode").length){ eval($(".cart.table-wrap .DiscountCode").data("callback")+"("+$(".cart.table-wrap .DiscountCode").trim()+")"); }
//   else {
//     $("#shopping-cart-totals-table").after('<div class="DiscountCode"></div>');
//     $(".cart.table-wrap .DiscountCode").load("https://www.nutramaxstore.com/checkout/ .reduction-code__text:last", function(){ eval($(".cart.table-wrap .DiscountCode").data("callback")+"("+$(".cart.table-wrap .DiscountCode").trim()+")"); });
//   }

// }

function RemoveFreeProduct(){
    //console.log("123 will remove unhandled free product");
    
    window.setTimeout(function(){
        $(".cart__row").each(function(index){
            if (!$(this).hasClass("handled-free-product") && $(this).find(".cart-price .money").text().trim() == "$0.00"){
                console.log("123 remove line"+index);
                document.location = "/cart/change?line="+index+"&quantity=0";
            } else {
                console.log("123 not removing line"+index);
            }
        });
    },0);
}

function BlockFreeOrders(){
    console.log("123 no free orders");
    if ($("#shopping-cart-totals-table > tbody > tr > td:nth-child(2) > span > span > span.wh-original-cart-total > span").text().trim() == "$0.00"){
        window.setTimeout(function(){
            $('[name="checkout"]').hide();
            $(".cart__row").css("visibility","hidden");
            
            $.ajax({
              type: "POST",
              url: '/cart/clear.js',
              success: function(){
                document.location.reload();
              },
              dataType: 'json'
            });            
        },0);
    }
}

function FreeVariantWithMinPurchase(variant_id, min_purchase){
    $('tr:contains("FREE")').addClass("handled-free-product").find(".cart-actions:visible").css("visibility","hidden");
    
	if ($(".wh-original-price").length && ($("#shopping-cart-totals-table > tbody > tr > td:nth-child(2) > span > span > span.wh-original-cart-total > span").text().replace("$","").trim()*1) >= min_purchase){ 
	    if (!$("input#updates_"+variant_id).length){
          	// meets criteria, not in cart
          	console.log("123 adding "+variant_id);
        	AddItemsToCart(variant_id, 1);	        
	    } else {
	        console.log("123 already added "+variant_id);
	    }

    } else if ($("input#updates_"+variant_id).length){
        window.setTimeout(function(){
            $("input#updates_"+variant_id).closest(".cart__row").addClass("remove-me");
            $(".cart__row").each(function(index){
                if ($(this).hasClass("remove-me")){
                    console.log("123 /cart/change?line="+index+"&quantity=0");
                    document.location = "/cart/change?line="+index+"&quantity=0";
                }
            });
        },0);
        
        // window.setTimeout(function(){
        //     $("input#updates_"+variant_id).closest(".cart__row").addClass("remove-me");
        //     $(".cart__row").each(function(index){
        //         if ($(this).hasClass("remove-me")){
        //             console.log("123 /cart/change?line="+index+"&quantity=0");
        //             document.location = "/cart/change?line="+index+"&quantity=0";
        //         }
        //     });
        // },1000);
        
        // in cart, does not meet criteria
        //window.setTimeout(function(){ console.log("123 removing "+variant_id+" "+$(".v_"+variant_id+" a.remove-item").attr("href")); },1000);
        
      	//$("input#updates_"+variant_id).closest(".cart__row").find("a.remove-item").click();
      	//document.location = $("input#updates_"+variant_id).closest(".cart__row").find("a.remove-item").attr("href");
    	//AddItemsToCart(31247889203262, 1);
    } else {
        // not in cart, does not meet criteria
        console.log("123 not adding "+variant_id);
        //console.log("123 "+$(".wh-original-cart-total.wh-original-price").text().replace("$","").trim()*1);
        // console.log("123 "+min_purchase);
        // console.log("123 "+$("input#updates_"+variant_id).length);
    }
}

HideRelatedProductsOnMerchandisePages(); 


// (function ($) {
//   $.each(['show', 'hide'], function (i, ev) {
//     var el = $.fn[ev];
//     $.fn[ev] = function () {
//       this.trigger(ev);
//       return el.apply(this, arguments);
//     };
//   });
// })(jQuery);


function HideRelatedProductsOnMerchandisePages(){
  if (location.hash == "#Merchandise"){ 
    $(".products-related").hide();
  }
  window.setInterval(function(){  
    if (location.hash == "#Merchandise"){ 
      $(".products-related").hide();
    }
  },1200);  

  
  //     if (location.hash == "#Merchandise"){
//       $(".products-related").on("show", function(){
//           $(".products-related").hide();
//       });
//     }

}



function subMent() {
      var suppFacts = document.querySelector(".supplement-facts-image img"),
          suppFactsIMG = document.querySelectorAll(".supplement-facts-image"),
          suppWrap = document.querySelector(".supplement-facts-image-wrapper"),
          h3vsf = document.querySelectorAll(".vsf"),
          MoreSuppWrap = document.querySelector(".More-supplement-facts-wrapper"),
          moreSupInfo = document.querySelector("#moreSupInfo");

        if(suppWrap !== null && suppFacts !== null){
          suppWrap.innerHTML = "<img src='" + suppFacts.src + "' alt='Suplement Facts'>";
        }

      var innerFun = function innerFun($el) {
        ($el !== null) ? $el.classList.add("hidden") : $-1;
      };

      var innerFunForEach = function innerFunForEach($id) {
        [].forEach.call($id, function (el) {
          el !== null ? el.classList.add("hidden") : $ - 1;
        });
      };

      innerFunForEach(suppFactsIMG);
      innerFunForEach(h3vsf);

      innerFun(MoreSuppWrap)

      function moreInfoFun() {
        if (MoreSuppWrap !== null && moreSupInfo !== null) {
          MoreSuppWrap.innerHTML = moreSupInfo.innerHTML;
          moreSupInfo.classList.add("hidden");
        }
      }
}

setTimeout(function () {
  ResizePage();
  window.onresize = function () {
    ResizePage();
  };
}, 3000);

function ResizePage() {
  if (jQuery(window).width() <= 767) {
    $(".mobile-button").addClass("active");
    $(".custom-footer-content").css("display", "none");
  } else {
    $(".mobile-button").removeClass("active");
    $(".custom-footer-content").css("display", "block");
  }
}
/* End close the accordion on smaller screen  */

/* Superscript all registed marks on the product title  
setTimeout(function () {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    $(".actions.vgsp-button-group").hide();
  }
}, 1000);
*/

/* Superscript all registed marks on the product title  */
setTimeout(function () {
  $(".product-name, .page-title span,.moreInfo__title").each(function(){
    $(this).html($(this).html().replace(/&reg;/gi, '<sup>&reg;</sup>').replace(/®/gi, '<sup>&reg;</sup>'));
  });
}, 1000);
/* End Superscript all registed marks on the product title */

function limitFunc() {
  var sImg = document.querySelectorAll(".slide.image-slide img");
  var nivoImg = document.querySelector("img.nivo-main-image");
    
  [].forEach.call(sImg, function (el, i) {
      if (window.innerWidth < 415) {
        nivoImg.src = "https://www.nutramax.biz/store/images/ConsumerCare-Mobile-v5-0.jpg";
        sImg[i].src = "https://www.nutramax.biz/store/images/ConsumerCare-Mobile-v5-" + i + ".jpg";
      } else {
        sImg[i].src = "https://www.nutramax.biz/store/images/nivo_slide_" + ++i + ".jpg";
      }
    });
}

// function disclaimer() {
//   var sb = document.querySelector(".section-block.home-collection-products-2");
//   if (sb) {
//     var xb = (sb.innerHTML += '<div class="container"><div class="home-collection-products-2__offer col-md-12">' +
//         "<sup>&dagger;</sup>Offer applies to orders placed at 1-877-COSAMIN (1-877-267-2646) or online at NutramaxStore.com. Offer valid May 1, 2018 through May 31, 2018 while supplies last. Free shipping on all orders $40.00 or more. AK and HI, add a surcharge of $15.00. You should receive your order within 7-10 business days. Qualifying purchases must be made by legal residents of the 50 United States or DC, 18 years and over. Improper use constitutes fraud. May not be combined with any other offer. Free goods are not returnable or redeemable for any other product. To ensure best availability, offer limited to five (5) free promotions per person during the promotion period.VOID WHERE PROHIBITED.</div></div>");
//   }
// }

function initialize() {  
  if (window.innerWidth < 415) {
    limitFunc();
  }
}

window.onload = initialize;
window.addEventListener("resize", limitFunc);

// $(document).ready(function(){
// 	$(".section-block.home-collection-products-2").append('<div class="container"><div class="home-collection-products-2__offer col-md-12">' +
//   "<sup>&dagger;</sup>Offer applies to orders placed at 1-877-COSAMIN (1-877-267-2646). Offer valid May 1, 2019 through May 31, 2019 while supplies last. Free shipping on all orders $90.00 or more. AK and HI, add a surcharge of $15.00. You should receive your order within 7-10 business days. Qualifying purchases must be made by legal residents of the 50 United States or DC, 18 years and over. Improper use constitutes fraud. May not be combined with any other offer. Free goods are not returnable or redeemable for any other product. To ensure best availability, offer limited to two (2) promotions per person during the promotion period. VOID WHERE PROHIBITED.</div></div>");
// });

// $(document).ready(function(){
// 	$(".section-block.home-collection-products-2").append('<div class="container"><div class="home-collection-products-2__offer col-md-12">' +
//   "<sup>*</sup>Offer applies to orders placed at 1-877-COSAMIN (1-877-267-2646). Offer valid December 2nd, 2019 through December 31st, 2019, while supplies last. Free shipping on all orders $90.00 or more. AK and HI, add a surcharge of $15.00. You should receive your order within 7-10 business days. Qualifying purchases must be made by legal residents of the 50 United States or DC, 18 years and over. Improper use constitutes fraud. May not be combined with any other offer. Free goods are not returnable or redeemable for any other product. To ensure best availability, offer limited to ten (10) promotions per household during the promotion period. VOID WHERE PROHIBITED.</div></div>");
// });

console.log("loaded asset nmx.js");


$(document).ready(function(){
	UseCartQtyUpdateFix();
});

function UseCartQtyUpdateFix(){
  	if (location.pathname.indexOf("/cart") == -1){ return; }
  
  	$("[name='checkout']").css("width","100%");
  	$(".product-qty .btn-button.btn-update").hide();
  	$(".product-qty .btn-button.btn-update:first").addClass("nmx").removeAttr("type").css("width","100%").insertBefore($("[name='checkout']"));

    
  	$(".product-qty input").unbind().keydown(function(){ 
      $("[name='checkout']").hide();
      $(".btn-button.btn-update.nmx").removeAttr("type").css("background","#f44336").css("cursor","pointer").text("Refresh Totals").show();
      
    }).blur(function(){ window.stop(); });
  
  	$(".reduced.items, .increase.items").click(function(){ 
      $("[name='checkout']").hide(); 
      $(".btn-button.btn-update.nmx").removeAttr("type").css("background","#f44336").css("cursor","pointer").text("Refresh Totals").show();
      
    });

}

useTestModeCookies();
//$(document).ready(function(){ useTestModeCookies(); });
window.onhashchange = useTestModeCookies;

function useTestModeCookies(){
    var expdate = new Date();
    expdate.setDate(expdate.getDate());
  
  	if (location.search.indexOf("notest")>-1){
    	setCookie("test_view","1",-1);
      	//location = location.href.replace("?notest","");
    } else if (location.search.indexOf("test")>-1){
    	setCookie("test_view","1");
      	//location = location.href.replace("?test","");
    }
  
  	var msg = "";
  
  	if (location.hash=="#notest"){
    	setCookie("test_view","1",-1);
      	msg = "(You may need to refresh the page.)";
    } else if (location.hash=="#test"){
    	setCookie("test_view","1");
      	msg = "(You may need to refresh the page.)";
    }
  
  	
  	if (getCookie("test_view") == "1"){ $("html").addClass("test-view").attr("test_view", getCookie("test_view")); console.log("TEST VIEW"+msg); console.log("Use https://"+location.hostname+"?notest to leave test view."); }
  	else if($("html[test_view]").length){ $("html").removeClass("test-view").removeAttr("test_view"); console.log("PUBLIC VIEW "+msg); }
}

$(document).ready(function(){ FixupBoosterAppDiscountCodeForm(1); });

function FixupBoosterAppDiscountCodeForm(sec){
  	if (location.pathname.indexOf("/cart") == -1){ return; }
  	if (!getCookie("test_view")){ return; } // test view
  	//console.log("FixupBoosterAppDiscountCodeForm9");
  
  	jQuery(".checkout-cart .booster-messages").remove();
    
    if (jQuery(".cart-wrapper.hover-content .booster-messages").length){
      
      jQuery(".cart-wrapper.hover-content .booster-messages").insertAfter("#shopping-cart-totals-table");

      if($("#booster-discount-code").val()!=""){
        	var discount_val = $("#booster-discount-item span:last").text();
        	//$("#booster-discount-item").html('<div class="nmx-booster-app-discount-item"><div class="nmx-booster-discount-code">'+$("#booster-discount-code").val()+'</div><div class="nmx-discount_val">'+discount_val+'</div><div class="remove-nmx-booster-app-discount-item">x</div></div>');
      		//$(".booster-discounts-wrapper").hide();
      }
      
      $("#booster-discount-code").val("").on('keydown', function (e) {
            if (e.keyCode == 13) {
              	e.preventDefault();
              	$("#apply-booster-discount").click();
            }
      });      
    } else{
      window.setTimeout(function(){ FixupBoosterAppDiscountCodeForm(sec); },sec*1000);
    }
  
    //jQuery(".checkout-cart .booster-messages").prependTo(".cart-wrapper.hover-content");
}


function skuShow() {
    var se = document.querySelectorAll('.swatch-element input');
    var sb = document.querySelectorAll('.product-type-data .sku-box');
    var sf = document.querySelectorAll('.supplement-facts-image-wrapper');
    [].forEach.call(sb, function (el, i) {
      el.classList.add('item' + i);
      document.querySelector('.sku-box.item0').classList.add('active');
    });
    [].forEach.call(sf, function (el, i) {
      el.classList.add('item' + i);
      document.querySelector('.supplement-facts-image-wrapper.item0').classList.add('active');
    });
    [].forEach.call(se, function (el, i) {
      el.addEventListener('click', function () {
        var sn = document.querySelector('.product-type-data .sku-box.item' + i);
        var sall = document.querySelectorAll('.product-type-data .sku-box');
        var sup = document.querySelector('.supplement-facts-image-wrapper.item' + i);
        var fac = document.querySelectorAll('.supplement-facts-image-wrapper');
        [].forEach.call(sall, function (el) {
          el.classList.remove('active');
        });
        if (!sn.classList.contains('active')) {
          sn.classList.add('active');
        }
        [].forEach.call(fac, function (el) {
          el.classList.remove('active');
        });
        if (!sup.classList.contains('active')) {
          sup.classList.add('active');
        }
      });
    });
}



window.onload = setTimeout(function () {
  var test = document.querySelector('html.test-view');
  var fac = document.querySelectorAll('.supplement-facts-image-wrapper');
  if(true){
    skuShow();
    [].forEach.call(fac, function (el) {
      el.classList.remove('hidden');
    });
  }
  var pressed = [];
  var secretCode = 'ashleytest';

  window.addEventListener('keyup', function(e) {
      pressed.push(e.key);
      pressed.splice(-secretCode.length - 1, pressed.length - secretCode.length);
      if (pressed.join('').includes(secretCode)) {
          var html = document.querySelector('html');
          html.classList.add('test-view');
          [].forEach.call(fac, function (el) {
            el.classList.remove('hidden');
          });
          skuShow();
          console.log('DING DING!');
      }
  });
}, 2000);






























useCustomBADiscounts();

function useCustomBADiscounts(){
	if (document.location.search.indexOf("test") == -1){ return; }

    window.setTimeout(function(){
        if (jQuery(".product-table .product__description:contains('Cosamin®ASU 230 Capsules')").length){ 
            initCustomBADiscounts(); 

        }
    },500);
}

function initCustomBADiscounts(){
	window.setInterval(function(){
    	jQuery(".applied-reduction-code__clear-button").attr("onmousedown","window.setTimeout(function(){ CustomDiscounts(); },1000);");
    },2000);
    
    CustomDiscounts();
}

function CustomBADiscounts(){
	//ApplyCosamin230Discount();
}


function ApplyCosamin230Discount(){
	//nmxfriend15

    if (jQuery(".product-table .product__description:contains(' ')").length){
        if (ApplyCouponCode("NMXFRIEND10")){
            //jQuery(".product-table .product__description:contains('Cosamin®ASU 230 Capsules') .order-summary__small-text").text("15% discount");
        	            
            window.setTimeout(function(){
            	
				//jQuery(".total-line--reduction").hide();
                //jQuery(".total-line--reduction .applied-reduction-code__information").text('15% Off Cosamin®ASU 230');
                jQuery(".total-line--reduction .total-line__name").css("white-space","nowrap");
                //Cosamin®ASU 230 Capsules
                
                var c_price = jQuery(".product-table .product__description:contains('Cosamin®ASU 230 Capsules')").closest(".product").find(".product__price .order-summary__emphasis").text();
                var d_amount = jQuery(".total-line--reduction .order-summary__emphasis").text().replace("-","");
                
                var p = /[^0-9.-]+/g;
				var d_price = "$"+ (parseFloat(c_price.replace(p, ''))-parseFloat(d_amount.replace(p, ''))).toFixed(2);
                
				//jQuery(".product-table .product__description:contains('Cosamin®ASU 230 Capsules') .order-summary__small-text").text("15% Off");
                //jQuery(".product-table .product__description:contains('Cosamin®ASU 230 Capsules') .order-summary__small-text").text("15% Off (Save "+d_amount+")");
                
                
                //jQuery(".product-table .product__description:contains('Cosamin®ASU 230 Capsules') .order-summary__small-text").text("15% Off (Reg: "+c_price+")");
                //jQuery(".product-table .product__description:contains('Cosamin®ASU 230 Capsules')").closest(".product").find(".product__price .order-summary__emphasis").text(d_price);
                
            },1000);
        	
        }

        //window.setTimeout(function(){
        //    jQuery(".order-summary__section--discount").hide();
        //    jQuery(".order-summary__section").css("border","none");
        //},1000);     
    }
}

function ApplyBACouponCode(code){
	jQuery(".total-line--reduction").show();
    
	if (jQuery(".applied-reduction-code__information").length && jQuery(".applied-reduction-code__information").text() == code){
    	return true;
        
    } else if (!jQuery("#error-for-reduction_code").length && !jQuery(".applied-reduction-code__information").length){
        jQuery("#checkout_reduction_code").val(code);
        jQuery(".edit_checkout button.field__input-btn.btn.btn--disabled:contains('Apply')").removeAttr("disabled");
        jQuery(".edit_checkout button.field__input-btn.btn").click();
        
        return true;
    }

    return false;
}


function nweekbanner() {
  var nweek = document.querySelectorAll('.nweekbanner');
  var d = new Date();
  var year = d.getFullYear();
  var month = ("0" + (d.getMonth() + 1)).substr(("0" + (d.getMonth() + 1)).length - 2);
  var day = ("0" + d.getDate()).substr(("0" + d.getDate()).length - 2);
  var stardate = (year + "" + month + "" + day);

  if (stardate < 20180513) {
    [].forEach.call(nweek, function (el) {
      el.classList.remove('hidden');
    });
  }
}

window.onload = nweekbanner;















function qs(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return ''; // or null
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


// cookie functions
function setCookie(c_name, value, expiredays) {
		var exdate = new Date();
		exdate.setDate(exdate.getDate() + expiredays);
		document.cookie = c_name + "=" + escape(value) +
		((expiredays == null) ? "" : ";expires=" + exdate.toUTCString()) + ";";
}


function getCookie(c_name) {
		var cookie = document.cookie.replace(/; /g, ";") + ";";
		var cookie = document.cookie;
		
		if (cookie.length > 0) {
				c_start = cookie.indexOf(c_name + "=");
				if (c_start != -1) {
						c_start = c_start + c_name.length + 1;
						c_end = cookie.indexOf(";", c_start);
						if (c_end == -1) c_end = cookie.length;
						return unescape(cookie.substring(c_start, c_end));
				}
		}
		return "";
}


$(document).ready(function(){
  window.setTimeout(function(){
    if (getCookie("test_view") == "1"){
      //$("head").append('<link rel="StyleSheet" type="text/css" href="https://www.nutramax.biz/mods/shopify.bogo/nmx.css">');
      //$("head").append('<script src="https://www.nutramax.biz/mods/shopify.bogo/nmx.js" type="application/javascript" async></script>');

      //
        //UseSpecialVariants();
        //TmpFixupProductPageVerdeSpecial()
      //
      
      NoCouponWithOffer();
		      
      
    }
  },0);
});










$(document).ready(function(){
	UseSpecialVariants();
});

/* 	@ D chekol 2018-10-03 
    @ Non us email filter custom message
*/

$(document).ready(function(){
	jQuery('input[type="submit"]').click(function(){
       if(jQuery(".non-us-email").length) {
           jQuery("#Email")[0].setCustomValidity("Email format invalid, or Non-US domain.");
       }
    });
});



/*!
 * currency.js - v1.1.4
 * http://scurker.github.io/currency.js
 *
 * Copyright (c) 2018 Jason Wilson
 * Released under MIT license
 */
(function(f,d){"object"===typeof exports&&"undefined"!==typeof module?module.exports=d():"function"===typeof define&&define.amd?define(d):f.currency=d()})(this,function(){function f(b,a){if(!(this instanceof f))return new f(b,a);a=l({},m,a);var c=Math.pow(10,a.precision);this.intValue=b=d(b,a);this.value=b/c;a.increment=a.increment||1/c;a.groups=a.useVedic?n:p;this.s=a;this.p=c}function d(b,a){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:!0,g=a.decimal,d=a.errorOnInvalid;var e=Math.pow(10,
a.precision);var h="number"===typeof b;if(h||b instanceof f)e*=h?b:b.value;else if("string"===typeof b)d=new RegExp("[^-\\d"+g+"]","g"),g=new RegExp("\\"+g,"g"),e=(e*=b.replace(/\((.*)\)/,"-$1").replace(d,"").replace(g,"."))||0;else{if(d)throw Error("Invalid Input");e=0}e=e.toFixed(1);return c?Math.round(e):e}var l=Object.assign||function(b){for(var a=1;a<arguments.length;a++){var c=arguments[a],g;for(g in c)Object.prototype.hasOwnProperty.call(c,g)&&(b[g]=c[g])}return b},m={symbol:"$",separator:",",
decimal:".",formatWithSymbol:!1,errorOnInvalid:!1,precision:2},p=/(\d)(?=(\d{3})+\b)/g,n=/(\d)(?=(\d\d)+\d\b)/g;f.prototype={add:function(b){var a=this.s,c=this.p;return f((this.intValue+d(b,a))/c,a)},subtract:function(b){var a=this.s,c=this.p;return f((this.intValue-d(b,a))/c,a)},multiply:function(b){var a=this.s;return f(this.intValue*b/Math.pow(10,a.precision),a)},divide:function(b){var a=this.s;return f(this.intValue/d(b,a,!1),a)},distribute:function(b){for(var a=this.intValue,c=this.p,g=this.s,
d=[],e=Math[0<=a?"floor":"ceil"](a/b),h=Math.abs(a-e*b);0!==b;b--){var k=f(e/c,g);0<h--&&(k=0<=a?k.add(1/c):k.subtract(1/c));d.push(k)}return d},dollars:function(){return~~this.value},cents:function(){return~~(this.intValue%this.p)},format:function(b){var a=this.s,c=a.formatWithSymbol,d=a.symbol,f=a.separator,e=a.decimal;a=a.groups;"undefined"===typeof b&&(b=c);b=((b?d:"")+this).split(".");c=b[1];return""+b[0].replace(a,"$1"+f)+(c?e+c:"")},toString:function(){var b=this.s,a=b.increment;return(Math.round(this.intValue/
this.p/a)*a).toFixed(b.precision)},toJSON:function(){return this.value}};return f});




function NoCouponWithOffer(){
  $(".order-summary__small-text").each(function(){
    if($(this).text().indexOf("BOGO 50% Off") > -1){
    	$(".order-summary__section--discount").hide();
    }
  });
}



function UseSpecialVariants(){
  console.log("%cNutramax BOGO Script", "color:red; font-weight:bold;");
  
  if (location.href.indexOf("/cart") > -1){
    FixupCart();
    
  	//$(".cart__meta-text").each(function(){ $(this).text($(this).text().replace("Discount: ","")); });
  	HandleBOGOVariantsInCart(12121985417278, 12121991610430);
    
  } 
  
  window.setTimeout(function(){
    if ($(".product-form [id]").length && $("#product-variants label:contains('Discount')").length){ 
      var selected_variant_id = $(".product-form").attr("id").replace("product_form_","");
      var selected_variant = $(".product-form option:selected").val();

      $(".bogo-msg").remove();
      $(".product-type-main").before('<div id="ribbon"><span id="content">'+selected_variant+'</span></div>');  

    /* variants are hidden by default in nmx.css */
      //$(".single-option-selector option:contains(' get ')").each(function(){
      //  $(this).closest(".selector-wrapper").addClass("hidden");
      //});
      //$(".selector-wrapper:not(.hidden)").addClass("available");

    }
  },1000);  
  
}


function FixupCart(){
  //$("input[name='checkout']").attr("type","button").click(function(){ location = "/checkout"; });
  
  $("body").addClass("bogo-ready");
  $(".data-table.cart-table tr").addClass("cart__row");  
}


function HandleBOGOVariantsInCart(buy_one, get_one){
  console.log("buy_one: "+buy_one);
  console.log("get_one: "+get_one); 
  
  var has_buy_one = $("a[href*='variant="+buy_one+"']").length>0;
  var has_get_one = $("a[href*='variant="+get_one+"']").length>0;
  
  console.log("has_buy_one: "+has_buy_one);
  console.log("has_get_one: "+has_get_one);
  
  var buy_one_qty = 0;
  var get_one_qty = 0;
  
  if (has_buy_one){
    var buy_one_qty = $("#updates_"+buy_one+"").val()*1;
    var buy_one_text = $("a[href*='variant="+buy_one+"']").closest(".cart__row").find("h5.product-name").next().text().trim();
    //var buy_one_text2 = $("a[href*='variant="+buy_one+"']").closest(".cart__row").find("h5.product-name a").text().trim();
    var buy_one_title = $("a[href*='variant="+buy_one+"']").closest(".cart__row").find("h5.product-name a").text().trim();
    var buy_one_price = $("a[href*='variant="+buy_one+"']").closest(".cart__row").find(".cart-price").text().trim().replace("$","");
 	  var buy_one_subtotal = currency(buy_one_price*buy_one_qty, { formatWithSymbol: false }).format();
    
    console.log("buy_one_qty: "+buy_one_qty);
    console.log("buy_one_title: "+buy_one_title);
    console.log("buy_one_text: "+buy_one_text);
    //console.log("buy_one_text2: "+buy_one_text2);
    console.log("buy_one_price: "+buy_one_price);
    console.log("buy_one_subtotal: "+buy_one_subtotal);
  }   
  
  
  if (has_get_one){
    var get_one_qty = $("#updates_"+get_one+"").val()*1;
  	var get_one_text = $("a[href*='variant="+get_one+"']").closest(".cart__row").find("h5.product-name").next().text().trim();
    //var get_one_text2 = $("a[href*='variant="+get_one+"']").closest(".cart__row").find(".list-view-item__title .medium-up--hide").text().trim();
   	var get_one_title = $("a[href*='variant="+get_one+"']").closest(".cart__row").find("h5.product-name a").text().trim();     
    var get_one_price = $("a[href*='variant="+get_one+"']").closest(".cart__row").find(".cart-price").text().trim().replace("$","");
 	  var get_one_subtotal = currency(get_one_price*get_one_qty, { formatWithSymbol: false }).format();
    
  	console.log("get_one_qty: "+get_one_qty); 
  	console.log("get_one_title: "+get_one_title);    
   	console.log("get_one_text: "+get_one_text);
    //console.log("get_one_text2: "+get_one_text2);
    console.log("get_one_price: "+get_one_price);    
    console.log("get_one_subtotal: "+get_one_subtotal); 
  } 
  
  
  
  
  
  
  
  if (has_buy_one){
    var total_qty = ((buy_one_qty*1)+(get_one_qty*1));

    $("#updates_"+buy_one+"").hide().after('<div class="special-qty"><input id="special-total-qty-'+buy_one+'" class="special-total" value="'+total_qty+'" ovalue="'+total_qty+'"></div>');
    
    
    $("a[href*='variant="+buy_one+"']").closest(".cart__row").find(".product-qty .items.increase").click(function(){
        $("#special-total-qty-"+buy_one).val(($("#special-total-qty-"+buy_one).val()*1)+1);
      
      	UpdateCartQtys(buy_one, get_one);
    });

    $("a[href*='variant="+buy_one+"']").closest(".cart__row").find(".product-qty .items.reduced").click(function(){
        $("#special-total-qty-"+buy_one).val(($("#special-total-qty-"+buy_one).val()*1)-1);
    
      	UpdateCartQtys(buy_one, get_one);
    });    
    
  	
    // fix remove from cart to remove trigger and special items
    $("a[href*='variant="+buy_one+"']").closest(".cart__row").find(".remove-item").attr("href","#").click(function(){
    	UpdateCart("updates["+buy_one+"]=0&updates["+get_one+"]=0"); 
    });
    
    $("#special-total-qty-"+buy_one).on('keydown', function (e) {
        if (e.keyCode == 13) {
          if($("#special-total-qty-"+buy_one).val() != $("#special-total-qty-"+buy_one).attr("ovalue")){
            var total_qty = $("#special-total-qty-"+buy_one).val();
            var new_get_qty = Math.floor(total_qty/2);
            var new_buy_qty = (total_qty-new_get_qty);   

            UpdateCart("updates["+buy_one+"]="+new_buy_qty+"&updates["+get_one+"]="+new_get_qty);   
          }
        }
      
      	if (e.keyCode == 38) {
         	 $("#special-total-qty-"+buy_one).val(($("#special-total-qty-"+buy_one).val()*1)+1);
        }
      
      	if (e.keyCode == 40) {
         	 $("#special-total-qty-"+buy_one).val(($("#special-total-qty-"+buy_one).val()*1)-1);
        }
      
      	$("[name='checkout']").hide();
      	$(".checkout-types .btn-button.btn-update").show().css("background","#f44336").text("REFRESH TOTALS");
    });
    
    $("#special-total-qty-"+buy_one).on('keydown', function (e) {   
    	UpdateCartQtys(buy_one, get_one);
    });   
    
    $(".special-total").keyup(function(){
      if($("#special-total-qty-"+buy_one).val() != $("#special-total-qty-"+buy_one).attr("ovalue")){
      	$(".btn-button.btn-update").addClass("notice-update");      
      } else{
        $(".btn-button.btn-update").removeClass("notice-update"); 
      }

    });
     
//     $("#special-total-qty-"+buy_one).blur(function(){
//       if($("#special-total-qty-"+buy_one).val() != $("#special-total-qty-"+buy_one).attr("ovalue")){
//         var total_qty = $("#special-total-qty-"+buy_one).val();
//         var new_get_qty = Math.floor(total_qty/2);
//         var new_buy_qty = (total_qty-new_get_qty);

//         UpdateCart("updates["+buy_one+"]="+new_buy_qty+"&updates["+get_one+"]="+new_get_qty);   
//       }
//     });     
  }
  
  if (has_get_one){
    $("a[href*='variant="+buy_one+"']").closest(".cart__row").find("h5.product-name").next().after('<div class="special-discount-msg">Discount for '+get_one_qty+': $'+get_one_subtotal+' <span>($'+get_one_price+' ea.)</span></div>');
    //$("a[href*='variant="+buy_one+"']").closest(".cart__row").find("td:last").append("<div class='reg-subtotal'>$"+buy_one_subtotal+"</div><div class='special-subtotal'>$"+get_one_subtotal+"</div><div class='special-ext-subtotal'>$"+currency("$"+buy_one_subtotal+"").add(get_one_subtotal)+"</div>");
  } 
  
  
  
  
  
  
  
  if ((buy_one_qty-1) == get_one_qty){
    // add link to bogo item in cart
    //var bogo_link_text = "Add another and get 50% off!";
    //$("a[href*='variant="+buy_one+"']").closest(".cart__row").find(".cart__meta-text").append('<a href="javascript:AddItemsToCart('+get_one+', 1);" class="add-bogo">'+bogo_link_text+'</a>');
    console.log("567567 "+(buy_one_qty-1)+" != "+(get_one_qty));
    
  } else if (buy_one_qty != get_one_qty && buy_one_qty > 1 || (buy_one_qty < get_one_qty)){
    // redistribute items in cart
    var total_qty = buy_one_qty + get_one_qty;
    var new_get_qty = Math.floor(total_qty/2);
    var new_buy_qty = (total_qty-new_get_qty);      
    
    //location.reload();
    
      //$("#updates_"+buy_one+"").val(new_buy_qty);
      //$("#updates_"+get_one+"").val(new_get_qty);    
	console.log("123123 "+(buy_one_qty-1)+" != "+(get_one_qty));
    UpdateCart("updates["+buy_one+"]="+new_buy_qty+"&updates["+get_one+"]="+new_get_qty);
    
    //console.log("loop");
  }

   
  if (has_buy_one && has_get_one && buy_one_title == get_one_title){
    // group variants in cart
  	$("a[href*='variant="+buy_one+"']").closest(".cart__row").addClass("bogo-parent-item");
  	$("a[href*='variant="+get_one+"']").closest(".cart__row").addClass("bogo-child-item");//.insertAfter($("a[href*='variant="+buy_one+"']").closest(".cart__row"));  
  }

  
  
  
  //$("a[href*='variant=8468859650109']").closest(".cart__row").addClass("float-bogo-dialog");
  //$(".float-bogo-dialog a .cart__image").unwrap();
  //$(".float-bogo-dialog .medium-up--hide").remove();
  //$(".float-bogo-dialog a .cart__image").after('<div class="bogo-msg">Would you like to add another</div>');
    
}  



function UpdateCartQtys(buy_one, get_one){
  window.setTimeout(function(){
      console.log("UpdateCartQtys");
    
      var total_qty = $("#special-total-qty-"+buy_one).val();
      var new_get_qty = Math.floor(total_qty/2);
      var new_buy_qty = (total_qty-new_get_qty); 
    
	  if(!$("#updates_"+get_one+"").length){ new_buy_qty = total_qty; new_get_qty = 0; }    

      $("#updates_"+buy_one+"").val(new_buy_qty);
      $("#updates_"+get_one+"").val(new_get_qty);
    
      //UpdateCartSilent("updates["+buy_one+"]="+new_buy_qty+"&updates["+get_one+"]="+new_get_qty);
  
      console.log("- buy qty: "+new_buy_qty);
      console.log("- get qty: "+new_get_qty);
    
  },100);
}





// cookie functions
function setCookie(c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) +
    ((expiredays == null) ? "" : ";expires=" + exdate.toUTCString()) + ";";
}


function getCookie(c_name) {
  var cookie = document.cookie.replace(/; /g, ";") + ";";
  var cookie = document.cookie;

  if (cookie.length > 0) {
    c_start = cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      c_end = cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = cookie.length;
      return unescape(cookie.substring(c_start, c_end));
    }
  }
  return "";
}



function UpdateCartSilent(data){
  // UpdateCart("updates[8423553400893]=1&updates[8468859650109]=1");
    
  $.ajax({
    type: "POST",
    url: '/cart/update.js',
    data: data,
    dataType: "html",
    success: function(){ 
      //location.reload(); 
      console.log("cart updated in bg");
    }
  });
}

function UpdateCart(data){
  // UpdateCart("updates[8423553400893]=1&updates[8468859650109]=1");
    
  $.ajax({
    type: "POST",
    url: '/cart/update.js',
    data: data,
    dataType: "html",
    success: function(){ 
      location.reload(); 
    }
  });
}

function AddItemsToCart(variantId, qty){
  $.ajax({
    type: "POST",
    url: '/cart/add.js?quantity='+qty+'&id='+variantId,
    dataType: 'html',
    success: function(){
      location.reload(); 
    }
  });
}

function ClearCart(){
  $(function() {
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
        location.reload(); 
      },
      dataType: 'json'
    });
  });
}

$(document).ready(function(){
  function topBanner(date, el) {
    var main = document.querySelector('.main');
    var home = document.querySelector('#nutramax-laboratories-consumer-care-inc-online-store');
    var tumb = document.querySelector('#avmacol-tumbler');
    var dayb4EndDate = new Date(date);
    var todaysDate = new Date();
    if(main !== null && home == null || tumb !== null){
      if(dayb4EndDate.setHours(0,0,0,0) >= todaysDate.setHours(0,0,0,0)) {
        $(main).prepend( el );
      }
    }
  }
  
  setTimeout(function() {
    $('.owl-controls.clickable .owl-prev').each(function(){
      $(this).append( '<p class="prev_p nmxacs">Previous</p>' );
      $(this).attr("role", "alert");
    });
    $('.owl-controls.clickable .owl-next').each(function(){
      $(this).prepend( '<p class="prev_p nmxacs">Next</p>' );
      $(this).attr("role", "alert");
    });
    $('.owl-item').each(function(){
    	$(this).attr("tabindex","0");
    });
    $('.add-to-cart').each(function(){
      $(this).attr("tabindex","0");
      $(this).prepend( '<p class="prev_p nmxacs">Add To Cart</p>' );
    	$(this).attr("role", "alert");
    });
    $('.box-popup a.product-link').attr("tabindex","0");
  }, 1000);
  
  setTimeout(function() {
    //topBanner("12/02/2018",'<div class="Special-Container-Desktop"><a href="https://www.nutramaxstore.com/collections/black-friday-specials"><div class="Black-Friday-Banner-2018"></div></a></div><div class="Special-Container-Mobile"><a href="https://www.nutramaxstore.com/collections/black-friday-specials"><div class="Black-Friday-Banner-2018-m"></div></a></div>')
  }, 1000);

  function holidayBanner(date, el){
    var hm = document.querySelector(".holidyMessage");
    var dayb4EndDate = new Date(date);
    var todaysDate = new Date();
    if(dayb4EndDate.setHours(0,0,0,0) >= todaysDate.setHours(0,0,0,0) && hm !== null) {
      hm.innerHTML += el
    }
  }

  //holidayBanner("11/25/2018", "<p style='text-align:center;padding-bottom: 20px;'><em>In order for our employees and their families to enjoy Thanksgiving we will be closed Wednesday, November 21, 2018 at 3:00PM EST though Sunday, November 25, 2018. We will reopen at 8:30AM EST on Monday, November 26, 2018. Orders placed before 1:00PM EST on Wednesday, November 21, 2018 will be shipped that day. All orders placed after 1:00PM EST on Wednesday, November 21, 2018 will be shipped on or after November 26, 2018.   </em></p>")

  holidayBanner("01/01/2019", "<div class='holidayCont'><div class='holiday__item item1'><img src='https://www.nutramax.biz/store/images/2018-Christmas-Flyer_400.jpg'></div><div class='holiday__item item2'><p style='text-align:center;padding-bottom: 20px;'><em>In order for our employees and their families to enjoy the holiday season, our business office will be <b>closed</b> from Friday, December 21 at 5:00 PM EST through Tuesday, January 1, 2019.<br/> We will reopen at 8:30 AM EST on Wednesday, January 2, 2019.<br/> Orders placed by 2:00 PM EST on Friday, December 21 will be shipped that day.<br/> All orders placed after 2:00 PM EST on Friday, December 21 will be shipped on or after December 27, 2018.</em></p></div></div>");

});


jQuery.getJSON('https://ipapi.co/json/', function(data) {
  console.log(data);
  var countryName,flagImage ,distributerLink;

  //I add the class hidden to the product.liquid, and product-grid.liquid code. This will remove it if its not China. If you need to remove it, open the code, and look for the hidden on the .price-content(product-grid.liquid), and .price-box (product.liquid)
  if(data.country_name != "China"){
    var money = document.querySelectorAll('.price-content');
    var priceBox = document.querySelectorAll('.price-box'); 
    [].forEach.call(money, function (el,i) {
      el.classList.remove('hidden')
    });
    [].forEach.call(priceBox, function (el,i) {
      el.classList.remove('hidden')
    });
  }

	if(data.country != 'US'){
    jQuery('body').addClass('outsideusa');
	}
	
	switch (data.country) {
		case 'KR':
			internationalDistributer('KR', true);
			break
		case 'HK':
			internationalDistributer('HK', true);
			break
		case 'CN':
			internationalDistributer('CN', true);
			break
		case 'PH':
			internationalDistributer('PH', true);
			console.log("This is Philippines")
			break
	}
	if(data.country_name == "China" || data.country == "CN" || data.currency === "CNY"){
    setTimeout(function () {
      internationalDistributer('CN', true);
      console.log("Hello China!");
    }, 1000);
  }
});

/* international distributer redirect   */

function internationalDistributer(countrycode, hideprice){ 
    jQuery('#interFwd,#internationalDistributor').remove();
    
     if(typeof countrycode == "undefined"){
       return false;
     }
     
  
    // var countryName,flagImage,distributerLink, productImage;
      
     jQuery('body').addClass(countrycode);
     
     if(hideprice){
       jQuery('body').addClass("hidepriceforthiscountry");
		 }
		 switch (countrycode) {
			case 'CN':
				countryName = 'China';
        		flagImage = 'https://cdn.shopify.com/s/files/1/1501/8950/files/china-flag.png';
        		distributerLink =  "http://rongxin.hk/"
				break;
			case 'HK':
				countryName = 'Hong Kong';
        		flagImage = 'https://ws.nutramax.biz/imgs/hk-flag.jpg';
        		distributerLink =  "http://rongxin.hk/";
				break;
			case 'PH':
				countryName = 'Philippines';
				flagImage = 'https://ws.nutramax.biz/imgs/ph-flag.png';
				distributerLink =  "https://www.nutrigineering.com/avmacol";
				break;
			case 'KR':
				countryName = 'South Korea';
        		flagImage = 'https://cdn.shopify.com/s/files/1/1501/8950/files/southkorea.png';
        		distributerLink =  "https://smartstore.naver.com/carrida/products/3261641314";
		}

     var productImage;
      if(location.href.indexOf('avmacol-immune')>-1 || location.href.indexOf('avmacol-extra-strength')>-1){
         productImage = "https://cdn.shopify.com/s/files/1/1501/8950/t/7/assets/avmacol-extra-strength-logo-2019.png";  
      }
      else if(location.href.indexOf('avmacol-60-tablet')>-1){
         productImage = "https://cdn.shopify.com/s/files/1/1501/8950/files/avmacol-img-popup-2019.png";
      } else {
         productImage = "https://cdn.shopify.com/s/files/1/1501/8950/files/avmacol-img-popup-2019.png";
      }
   
   setTimeout(function() {
       if(location.href.indexOf('avmacol')>-1 && location.href.indexOf('search') < 0){        

         	   //ga('send', 'event', 'International Distributor Button', 'Display', 'Avmacol/'+countryName+'');
         
               //popup
               jQuery('body').append('<div  class="fancybox-overlay fancybox-overlay-fixed" id="interFwd" style=""><div class="fancybox-wrap fancybox-desktop fancybox-type-image fancybox-opened" tabindex="-1" style=""><div class="fancybox-skin" style=""><div class="fancybox-outer"><div class="fancybox-inner" style=""><h2>Looking for <img src="'+productImage+'" title="Avmacol-immune" alt="Avmacol immune"> <br> in '+countryName+'?</h2><p>Click <a href="'+distributerLink+'" class="here" target="_blank" onclick="ga(\'send\', \'event\', \'International Distributor Button\', \'Click\', \'Avmacol/'+countryName+'\');">Here</a> to purchase <br> in '+countryName+'</p><a class="btn buy-now" href="'+distributerLink+'" target="_blank" style="" onclick="ga(\'send\', \'event\', \'International Distributor Button\', \'Click\', \'Avmacol/'+countryName+'\');">Buy Now</a>  </div></div><button title="Close" class="fancybox-item fancybox-close" onclick=document.getElementById("interFwd").style.display="none" ></button></div></div></div>');
               
               //at the product page
               jQuery('#product-form').append('<div style="" id="internationalDistributor"><img src="'+flagImage+'">Looking to purchase in '+countryName+'? <a class="btn buy-now" href="'+distributerLink+'" target="_blank" style="" onclick="ga(\'send\', \'event\', \'International Distributor Button\', \'Click\', \'Avmacol/'+countryName+'\');">Buy Now</a></div>');
            
               // close the window when we click outside the box
               jQuery(function() {
                    jQuery(document).on('click', function(e) {
                        if (e.target.id === 'interFwd') {
                           jQuery('#interFwd').css('display','none');
                        } else {
                           e.stopPropagation();            
                        }

                    })
                });
         
         
        }
        var cartBtnAv = document.querySelector('.item-i.pid11418698319 .addtocart');
        var cartBtnES = document.querySelector('.item-i.pid11418634831 .addtocart');
        cartBtnAv !== null ? cartBtnAv.classList.add('hidden') : -1;
        cartBtnES !== null ? cartBtnES.classList.add('hidden') : -1;
     
  }, 1000);
  
}


/* end international distributer redirect   */



/* Verde givewaya redirect   */
$(document).ready(function(){
  
if(location.href.indexOf('free-cosamin-verde-80-tablets')>-1){
  window.location.href = "https://www.nutramaxstore.com/collections/joint-health-products/products/cosamin-verde-80-tablets#JointHealth";
}
//  if(getCookie('test_view')=="1" ){
//    jQuery('.holidyMessage').css('display','block');
//  }
});
/* end Verde givewaya redirect  */


function clearPlace() {
  var cp = document.querySelector('.btextarea textarea#story');
  if (cp != null && cp.placeholder.includes("<br>")) {
      cp.placeholder = cp.placeholder.replace("<br>", " ");
  }
}

function isInTest() {
  var body = document.querySelector('body');
  if (body.hasAttribute('testmode')) {
    body.classList.add('test')
  }
}

function addImgAlt($ele,$text) {
  var item = document.querySelectorAll($ele);
  [].forEach.call(item, function (el,i) {
    el ? el.setAttribute("alt", $text) : -1;
  });
}

function addSpanForemptyLink($ine,$text) {
  var x = document.querySelectorAll($ine);
  if(x)
  {
    [].forEach.call(x, function (el,i) {
      el.innerHTML += $text;
    });
  }
}

function addText(ele) {
  var tim = document.querySelector(ele);
  if(tim){
    tim.innerHTML="true";
  }
}

function labelHelp() {
  var lps = document.querySelectorAll("label[for=product-select]");
  var lvI = document.querySelectorAll("label[for=variantID]");
  var svI = document.querySelectorAll("select#variantID");
  var sps = document.querySelectorAll("select#product-select");
  lps ? gofor(lps, "product-select") : -1;
  lvI ? gofor(lvI, "variantID") : -1;
  svI ? goforID(svI, "variantID") : -1;
  svI ? goforID(sps, "product-select") : -1;

  function gofor($sam, $nam) {
    [].forEach.call($sam, function (el, i) {
      el.htmlFor = "".concat($nam, "-").concat(i);
    });
  }

  function goforID($sam, $nam) {
    [].forEach.call($sam, function (el, i) {
      el.setAttribute('id', "".concat($nam, "-").concat(i));
    });
  }
}


function addtoCartCount(){
  var atc = document.querySelectorAll('.add-to-cart');
  var cartCount = document.querySelector('.cart-count');
  var popCount = document.querySelector('.popboxCount');
  if(atc){upDateCount()}
  function upDateCount (){
    [].forEach.call(atc, function (el,i) {
      el.addEventListener('click', function() {
        setTimeout(function () {
          popCount.innerHTML = cartCount.innerHTML
        }, 1000);
      });
    });
  }
}

function init2a() {
  var ssBtn = document.querySelector('.box-col-inner.box-col-1.success-stories-submit-form-btn.custom');
  if (ssBtn !== null) {
    ssBtn.addEventListener('click', function() {
      clearPlace()
    });
  }
  labelHelp();
  addtoCartCount();
  setTimeout(function () {
    isInTest();
    var recap = document.querySelector("input[name=recaptcha-v3-token]");
    if(recap){
      recap.setAttribute("id", "recapIn")
    }
    //$(".grecaptcha-badge").prepend("<label for='g-recaptcha-response-100000' style='display:none'>Recaptcha</label>");
    //$("form#contact_form").prepend("<label for='recapIn' style='display:none'>Recaptcha</label>");
    $(".mobile-enlarged-image").attr("tabindex", "0");
  }, 2000);
  
//   addImgAlt(".nivo-main-image","Nutramax Laboratories Consumer Care, INC.");
//   addImgAlt("img.crossed-out","Nutramax Laboratories Consumer Care, INC.");
  
//   addSpanForemptyLink(".quickview-wrapper","<span style='display:none'>Search</span>"); 
//   addText('button#cboxPrevious');
//   addText('button#cboxNext');
//   addText('button#cboxSlideshow');
//   nmxSiteAccessibility(20, 100);
  
}

window.onload = setTimeout(function () {init2a()}, 2000);